// can't use classList since IE doesn't support for SVG elements
// so going to have to resort to testing the className string
const isCloseButtonClass = (className) => {
  if (typeof className !== 'string') {
    return false;
  }
  const closeButtonClasses = {
    lightbox: true, // means black area around lightbox clicked
    lightbox__close: true,
    lightbox__close__icon: true
  };

  const hasCloseButtonClass = className
    .split(' ')
    .reduce((isTrueSoFar, currentClass) => {
      return isTrueSoFar || !!closeButtonClasses[currentClass];
    }, false);
  return hasCloseButtonClass;
};

const getLightspeedEvent = (action) => ({
  action,
  cta: 'ShopKeep is now part of the Lightspeed family',
  type: 'Lightspeed'
});

export default {
  isCloseButtonClass,
  getLightspeedEvent
};
